module.exports = __webpack_public_path__ + "img/banner_2.5D.5f8110a4.jpg";